import React from 'react';

import { Field, Formik } from 'formik';
import { connect } from 'react-redux';

import { submitPassword } from '../../actions/submitPassword.actions';
import TextField from '../../components/CstmTextField';
import ScreenWrapper from '../../components/ScreenWrapper';

const PasswordScreen = ({ submitPasswordProps }) => {
  return (
    <React.Fragment>
      <h1
        style={{
          textAlign: 'center',
          fontSize: '60px',
          fontStyle: 'normal',
          fontWeight: 600,
          marginTop: -10,
          marginBottom: 30,
        }}
      >
        Please enter profile password.
      </h1>

      <ScreenWrapper step={4}>
        <Formik
          initialValues={{ pms_password: '' }}
          onSubmit={values => {
            submitPasswordProps(values);
          }}
          validate={values => {
            let errors = {};

            if (!values.pms_password) {
              errors.pms_password = 'Required';
            }

            return errors;
          }}
        >
          {({ handleSubmit }) => (
            <React.Fragment>
              <Field
                name="pms_password"
                label="Password"
                component={TextField}
                type="password"
                required
              />

              <div style={{ marginTop: 10 }}>
                <div style={{ float: 'right' }}>
                  <button type="button" className="cstm_btn cstm_btn-blue" onClick={handleSubmit}>
                    Next
                  </button>
                </div>
              </div>
            </React.Fragment>
          )}
        </Formik>
      </ScreenWrapper>
    </React.Fragment>
  );
};

const mapDispatch = dispatch => {
  return {
    submitPasswordProps: values => {
      dispatch(submitPassword(values));
    },
  };
};

export default connect(null, mapDispatch)(PasswordScreen);



// WEBPACK FOOTER //
// ./src/Screens/PasswordScreen/index.js